(function attachJudesBundleRecipes(root) {
  'use strict';

  const pricingMode = 'standard_discount';

  const covers = {
    s1: [
      '54807944724748', '54807936336140', '54807933387020', '54807932961036',
      '40504362172605', '54440696054028',
      '54440700477708', '54440701427980', '54440702574860', '54108793766156',
      '54108814377228', '54108815589644', '54108816310540', '49243456340236',
      '49243467448588', '49243444052236', '49243473543436', '39662967816381',
      '40504337662141', '40504364826813', '41462371582141', '41462371647677',
      '41462371713213', '43799729111308', '43799767515404', '43799772791052'
    ],
    s2: [
      '54807936368908', '54807933419788', '54807932993804',
      '40504363352253', '54440699363596',
      '54440700936460', '54440702017804', '54440702935308', '54108793798924',
      '54108814409996', '54108815622412', '54108816343308', '49243457323276',
      '49243469414668', '49243453915404', '49243474755852', '40460580716733',
      '40504340873405', '40504366039229', '41462371614909', '41462371680445',
      '41462371745981', '43799743693068', '43799768105228', '43799773184268'
    ]
  };

  const wetbags = [
    '54782500569356', '54782485594380', '54782484807948', '54782475075852',
    '54276133847308', '54276133880076', '54276133912844', '54276133945612',
    '54807969759500', '54807971397900'
  ];
  const mats = ['54653996826892', '54653996859660', '54653996892428', '54653996925196'];

  function coverDesignGroup(id, label, variantIds, limit) {
    const group = { id, label, variantIds: Object.freeze(variantIds) };
    if (limit) group.limit = limit;
    return Object.freeze(group);
  }

  // Cover picker collections: display order and the order for replacing an unavailable design. Allowed
  // variants and pricing stay unchanged. Defaults and the first two presets derive from these groups.
  // Labels stay English in every locale. Most Popular is
  // the Klassik/Premium sales ranking (645 sets); the Builder shows its first `limit` designs that are available
  // in the buyer's market. The five collections list every allowed cover of a size exactly once (no Lilac
  // Size 2). Names follow the Shopify variant titles.
  const coverDesignGroups = {
    s1: Object.freeze([
      coverDesignGroup('most-popular', 'Most Popular', [
        '40504362172605', // Sage
        '41462371582141', // Sunny Dots
        '43799729111308', // Kale
        '39662967816381', // Aubergine
        '40504337662141', // Spinach
        '40504364826813', // Chickpea
        '49243467448588', // Sand
        '43799767515404', // Beetroot
        '41462371647677', // Cloudy Dots
        '54440696054028', // Buttercream
        '49243456340236', // Sea
        '41462371713213', // Dark Dots
        '54440702574860', // Mocha
        '43799772791052', // Plum
        '54440701427980', // Blueberry
        '49243444052236', // Rose
        '49243473543436', // Kale Dots
        '54440700477708', // Coral
        '54807936336140', // Matcha
        '54108816310540', // Warm Flow
        '54807944724748', // Lilac
        '54108814377228', // Soft Flow
        '54108815589644', // Cool Flow
        '54108793766156', // Bright Flow
        '54807932961036', // Dandelion
        '54807933387020' // Daisy
      ], 6),
      coverDesignGroup('soft-pastels', 'Soft Pastels', [
        '40504362172605', // Sage
        '40504337662141', // Spinach
        '49243467448588', // Sand
        '41462371647677', // Cloudy Dots
        '54440696054028', // Buttercream
        '49243444052236' // Rose
      ]),
      coverDesignGroup('rich-earthy', 'Rich & Earthy', [
        '43799729111308', // Kale
        '39662967816381', // Aubergine
        '40504364826813', // Chickpea
        '43799767515404', // Beetroot
        '54440702574860', // Mocha
        '43799772791052' // Plum
      ]),
      coverDesignGroup('prints-bold', 'Prints & Bold', [
        '41462371582141', // Sunny Dots
        '49243456340236', // Sea
        '41462371713213', // Dark Dots
        '54440701427980', // Blueberry
        '49243473543436', // Kale Dots
        '54440700477708' // Coral
      ]),
      coverDesignGroup('fleur-limited', 'Fleur Limited Edition', [
        '54807933387020', // Daisy
        '54807932961036', // Dandelion
        '54807944724748', // Lilac
        '54807936336140' // Matcha
      ]),
      coverDesignGroup('flow-limited', 'Flow Limited Edition', [
        '54108814377228', // Soft Flow
        '54108793766156', // Bright Flow
        '54108815589644', // Cool Flow
        '54108816310540' // Warm Flow
      ])
    ]),
    s2: Object.freeze([
      coverDesignGroup('most-popular', 'Most Popular', [
        '40504363352253', // Sage
        '41462371614909', // Sunny Dots
        '43799743693068', // Kale
        '40460580716733', // Aubergine
        '40504340873405', // Spinach
        '40504366039229', // Chickpea
        '49243469414668', // Sand
        '43799768105228', // Beetroot
        '41462371680445', // Cloudy Dots
        '54440699363596', // Buttercream
        '49243457323276', // Sea
        '41462371745981', // Dark Dots
        '54440702935308', // Mocha
        '43799773184268', // Plum
        '54440702017804', // Blueberry
        '49243453915404', // Rose
        '49243474755852', // Kale Dots
        '54440700936460', // Coral
        '54807936368908', // Matcha
        '54108816343308', // Warm Flow
        '54108814409996', // Soft Flow
        '54108815622412', // Cool Flow
        '54108793798924', // Bright Flow
        '54807932993804', // Dandelion
        '54807933419788' // Daisy
      ], 6),
      coverDesignGroup('soft-pastels', 'Soft Pastels', [
        '40504363352253', // Sage
        '40504340873405', // Spinach
        '49243469414668', // Sand
        '41462371680445', // Cloudy Dots
        '54440699363596', // Buttercream
        '49243453915404' // Rose
      ]),
      coverDesignGroup('rich-earthy', 'Rich & Earthy', [
        '43799743693068', // Kale
        '40460580716733', // Aubergine
        '40504366039229', // Chickpea
        '43799768105228', // Beetroot
        '54440702935308', // Mocha
        '43799773184268' // Plum
      ]),
      coverDesignGroup('prints-bold', 'Prints & Bold', [
        '41462371614909', // Sunny Dots
        '49243457323276', // Sea
        '41462371745981', // Dark Dots
        '54440702017804', // Blueberry
        '49243474755852', // Kale Dots
        '54440700936460' // Coral
      ]),
      coverDesignGroup('fleur-limited', 'Fleur Limited Edition', [
        '54807933419788', // Daisy
        '54807932993804', // Dandelion
        '54807936368908' // Matcha
      ]),
      coverDesignGroup('flow-limited', 'Flow Limited Edition', [
        '54108814409996', // Soft Flow
        '54108793798924', // Bright Flow
        '54108815622412', // Cool Flow
        '54108816343308' // Warm Flow
      ])
    ])
  };

  function coverPalette(sizeKey, id) {
    const group = coverDesignGroups[sizeKey].find((candidate) => candidate.id === id);
    return group.limit ? group.variantIds.slice(0, group.limit) : group.variantIds;
  }

  const palettes = {
    'most-popular': {
      label: 'Most Popular',
      s1: coverPalette('s1', 'most-popular'),
      s2: coverPalette('s2', 'most-popular'),
      wetbags: ['54276133847308', '54276133945612', '54276133880076', '54276133912844'],
      mats: ['54653996826892', '54653996925196', '54653996859660']
    },
    'soft-pastels': {
      label: 'Soft Pastels',
      s1: coverPalette('s1', 'soft-pastels'),
      s2: coverPalette('s2', 'soft-pastels'),
      wetbags: ['54782484807948', '54276133847308', '54276133912844', '54782500569356'],
      mats: ['54653996826892', '54653996859660']
    },
    'rich-earthy': {
      label: 'Rich & Earthy',
      s1: ['54440702574860', '39662967816381', '43799729111308', '43799772791052', '40504364826813', '43799767515404'],
      s2: ['54440702935308', '40460580716733', '43799743693068', '43799773184268', '40504366039229', '43799768105228'],
      wetbags: ['54782485594380', '54276133880076', '54276133945612', '54782475075852'],
      mats: ['54653996892428', '54653996925196']
    },
    'prints-bold': {
      label: 'Prints & Bold',
      s1: ['41462371582141', '49243456340236', '54108816310540', '49243473543436', '54440700477708', '54108815589644'],
      s2: ['41462371614909', '49243457323276', '54108816343308', '49243474755852', '54440700936460', '54108815622412'],
      wetbags: ['54276133912844', '54276133945612', '54782484807948', '54782485594380'],
      mats: ['54653996859660', '54653996925196']
    }
  };

  const routines = {
    starter: {
      slug: 'starter', label: 'Starter',
      description: 'For families who want to start gently with 2 to 3 changes a day.',
      perks: ['The smallest start, mix freely with disposables', 'Add more pieces any time'],
      one: { covers: 2, wetbags: 1, mats: 1, inner: 6, poo: 1, wipes: 1, booster: 1, largeBag: 1, share: '25 %', plastic: '125 kg', savings: '€375', impactSegments: [1, 1, 1] },
      both: { covers: 2, wetbags: 1, mats: 1, inner: 7, poo: 1, wipes: 1, booster: 1, largeBag: 1, share: '25 %', plastic: '250 kg', savings: '€750', impactSegments: [1, 1, 1] }
    },
    part: {
      slug: 'part-time', label: 'Part Time',
      description: 'Popular among families who want to combine Judes 50/50 with disposable diapers.',
      perks: ['The easy first step, mix freely with disposables', 'Use Judes for 50% of changes'],
      one: { covers: 3, wetbags: 1, mats: 1, inner: 12, poo: 1, wipes: 2, booster: 2, largeBag: 1, share: '50 %', plastic: '250 kg', savings: '€750', impactSegments: [2, 1, 1] },
      both: { covers: 4, wetbags: 1, mats: 1, inner: 14, poo: 1, wipes: 2, booster: 2, largeBag: 1, share: '50 %', plastic: '500 kg', savings: '€1,500', impactSegments: [2, 2, 2] }
    },
    full: {
      slug: 'full-time', label: 'Full Time',
      description: 'For families who diaper with Judes day and night.',
      perks: ['Diaper 100 % with Judes, no disposables needed'],
      one: { covers: 6, wetbags: 2, mats: 1, inner: 21, poo: 1, wipes: 3, booster: 3, largeBag: 1, share: '100 %', plastic: '333 kg', savings: '€1,000', impactSegments: [4, 1, 1] },
      both: { covers: 6, wetbags: 2, mats: 1, inner: 21, poo: 1, wipes: 3, booster: 3, largeBag: 2, share: '100 %', plastic: '750 kg', savings: '€2,250', impactSegments: [4, 3, 3] }
    },
    comfort: {
      slug: 'comfort', label: 'Comfort',
      description: 'Our most popular set, enough diapers for a relaxed wash rhythm.',
      perks: ['Wash only every 3 to 4 days', 'Relaxed full-time diapering with Judes'],
      one: { covers: 8, wetbags: 2, mats: 1, inner: 28, poo: 1, wipes: 4, booster: 4, largeBag: 2, share: '100 %', plastic: '500 kg', savings: '€1,500', impactSegments: [4, 2, 2] },
      both: { covers: 8, wetbags: 2, mats: 1, inner: 28, poo: 1, wipes: 4, booster: 4, largeBag: 2, share: '100 %', plastic: '1,000 kg', savings: '€3,000', impactSegments: [4, 4, 4] }
    },
    allin: {
      slug: 'all-in', label: 'All-in',
      description: 'The complete package, everything you need from day one to potty training.',
      perks: ['Wash only every 4 to 5 days', 'Grandparents and daycare equipped too', 'Everything until potty training, never buy diapers or changing accessories again'],
      one: { covers: 10, wetbags: 3, mats: 2, inner: 35, poo: 2, wipes: 6, booster: 5, largeBag: 3, share: '100 %', plastic: '600 kg', savings: '€1,800', impactSegments: [4, 2, 2] },
      both: { covers: 10, wetbags: 3, mats: 2, inner: 35, poo: 1, wipes: 6, booster: 5, largeBag: 3, share: '100 %', plastic: '1,200 kg', savings: '€3,000', impactSegments: [4, 4, 4] }
    }
  };

  const parents = {
    s1: { part: '43568627908876', full: '43566863155468', comfort: '40529145331901', allin: '43566863188236' },
    s2: { part: '43568627941644', full: '43566863221004', comfort: '40529145397437', allin: '43566863253772' },
    s12: { part: '43570960531724', full: '43570960564492', comfort: '43570960597260', allin: '43570960630028' }
  };

  const gifts = {
    one: {
      starter: {},
      part: { poo: 1, booster: 1, wipes: 1 },
      full: { poo: 1, booster: 1, wipes: 1, smallWetbag: 1 },
      comfort: { poo: 1, booster: 1, wipes: 1, smallWetbag: 1, inner: 1 },
      allin: { poo: 1, booster: 1, wipes: 1, smallWetbag: 1, inner: 1, mat: 1 }
    },
    both: {
      starter: {},
      part: { poo: 1, booster: 1, wipes: 1, smallWetbag: 1, mat: 1 },
      full: { poo: 2, booster: 1, wipes: 1, smallWetbag: 1, mat: 1, largeBag: 1 },
      comfort: { poo: 2, booster: 1, wipes: 1, smallWetbag: 1, mat: 1, largeBag: 1, inner: 2 },
      allin: { poo: 2, booster: 1, wipes: 1, smallWetbag: 1, mat: 2, largeBag: 2, inner: 2 }
    }
  };

  const discountIdentifiers = {
    s1: { starter: 'cst1', part: 'cspt1', full: 'cssm1', comfort: 'csst1', allin: 'csai1' },
    s2: { starter: 'cst2', part: 'cspt2', full: 'cssm2', comfort: 'csst2', allin: 'csai2' },
    s12: { starter: 'pst', part: 'pspt', full: 'pssm', comfort: 'psst', allin: 'psai' }
  };

  const standardDiscountAmounts = {
    s1: { starter: 2330, part: 4285, full: 6610, comfort: 8850, allin: 11670 },
    s2: { starter: 2330, part: 4285, full: 6610, comfort: 8850, allin: 11670 },
    s12: { starter: 4175, part: 9775, full: 14465, comfort: 18765, allin: 24145 }
  };

  // Routines without a parent set variant use a dated suffix in the bb_ contract
  // and have no gift code, because they never had gift pricing.
  const parentlessCodeSuffix = '20260924';

  function repeat(values, quantity) {
    return Array.from({ length: quantity }, (_, index) => values[index % values.length]);
  }

  function parentVariantFor(sizeKey, routineKey) {
    return parents[sizeKey][routineKey] || null;
  }

  function giftDiscountCode(sizeKey, routineKey) {
    if (!parentVariantFor(sizeKey, routineKey)) return null;
    return `bb_${discountIdentifiers[sizeKey][routineKey]}_20260908`;
  }

  function standardDiscountCode(sizeKey, routineKey) {
    const suffix = parentVariantFor(sizeKey, routineKey) || parentlessCodeSuffix;
    return `bb_${discountIdentifiers[sizeKey][routineKey]}_${suffix}`;
  }

  function fixedItem(variantId, quantity, giftQuantity, label, includedLabel, includedOrder, includedQuantityMultiplier) {
    return { variantId, quantity, giftQuantity: giftQuantity || 0, label, includedLabel, includedOrder, includedQuantityMultiplier };
  }

  function choiceGroup(id, label, includedLabel, quantity, giftQuantity, allowedVariantIds, defaultVariantIds, designGroups) {
    const group = { id, label, includedLabel, quantity, giftQuantity: giftQuantity || 0, allowedVariantIds, defaultVariantIds };
    if (designGroups) group.designGroups = designGroups;
    return group;
  }

  function makePresets(sizeKey, quantities) {
    return Object.entries(palettes).map(([id, palette]) => {
      const selections = {};
      if (sizeKey === 's1' || sizeKey === 's12') selections['covers-size-1'] = repeat(palette.s1, quantities.covers);
      if (sizeKey === 's2' || sizeKey === 's12') selections['covers-size-2'] = repeat(palette.s2, quantities.covers);
      selections['small-wetbags'] = repeat(palette.wetbags, quantities.wetbags);
      selections['changing-mats'] = repeat(palette.mats, quantities.mats);
      return { id, label: palette.label, selections };
    });
  }

  function makeRecipe(sizeKey, routineKey) {
    const routine = routines[routineKey];
    const both = sizeKey === 's12';
    const quantities = routine[both ? 'both' : 'one'];
    const gift = gifts[both ? 'both' : 'one'][routineKey];
    const bundleType = both ? 'premium' : 'klassik';
    const sizeNumber = sizeKey === 's2' ? 2 : 1;
    const sizeLabel = sizeKey === 's1'
      ? 'Size 1 (3–8 kg)'
      : sizeKey === 's2' ? 'Size 2 (7–16 kg)' : 'Size 1 + 2 (3–16 kg)';
    const fixedItems = [];

    if (both) {
      fixedItems.push(fixedItem('40504412700861', quantities.inner, gift.inner || 0, 'Inner diapers, Size 1', 'Inner diapers, Size 1', 1));
      fixedItems.push(fixedItem('40460286296253', quantities.inner, 0, 'Inner diapers, Size 2', 'Inner diapers, Size 2', 2));
      fixedItems.push(fixedItem('43560222064908', quantities.poo, gift.poo ? 1 : 0, 'Poo Paper, Size 1', 'Poo paper, Size 1', 3));
      fixedItems.push(fixedItem('43560222097676', quantities.poo, gift.poo > 1 ? 1 : 0, 'Poo Paper, Size 2', 'Poo paper, Size 2', 4));
    } else {
      fixedItems.push(fixedItem(sizeNumber === 1 ? '40504412700861' : '40460286296253', quantities.inner, gift.inner || 0, 'Inner diapers', 'Inner diapers', 1));
      fixedItems.push(fixedItem(sizeNumber === 1 ? '43560222064908' : '43560222097676', quantities.poo, gift.poo || 0, 'Poo Paper', 'Poo paper', 2));
    }

    fixedItems.push(fixedItem('40504385011901', quantities.wipes, gift.wipes || 0, 'Wash cloths 10-pack', 'Wash cloths', both ? 5 : 3, 10));
    fixedItems.push(fixedItem('40504400871613', quantities.booster, gift.booster || 0, 'Booster 2-pack', 'Booster inserts', both ? 6 : 4, 2));
    fixedItems.push(fixedItem('40510891229373', quantities.largeBag, gift.largeBag || 0, 'Large diaper bag', 'Large diaper bags', both ? 7 : 5));

    const choiceGroups = [];
    if (sizeKey === 's1' || both) {
      choiceGroups.push(choiceGroup(
        'covers-size-1', both ? 'Diaper Covers · Size 1 (3–8 kg)' : 'Diaper Covers', 'Diaper cover',
        quantities.covers, 0, covers.s1, repeat(palettes['most-popular'].s1, quantities.covers),
        coverDesignGroups.s1
      ));
    }
    if (sizeKey === 's2' || both) {
      choiceGroups.push(choiceGroup(
        'covers-size-2', both ? 'Diaper Covers · Size 2 (7–16 kg)' : 'Diaper Covers', 'Diaper cover',
        quantities.covers, 0, covers.s2, repeat(palettes['most-popular'].s2, quantities.covers),
        coverDesignGroups.s2
      ));
    }
    choiceGroups.push(choiceGroup(
      'small-wetbags', 'Wetbags', 'Small diaper bag', quantities.wetbags, gift.smallWetbag || 0,
      wetbags, repeat(palettes['most-popular'].wetbags, quantities.wetbags)
    ));
    choiceGroups.push(choiceGroup(
      'changing-mats', 'Changing Mats', 'Changing mat', quantities.mats, gift.mat || 0,
      mats, repeat(palettes['most-popular'].mats, quantities.mats)
    ));

    return Object.freeze({
      id: `${bundleType}-${routine.slug}-${sizeKey}`,
      bundleType,
      parentVariantId: parentVariantFor(sizeKey, routineKey),
      routineKey,
      sizeKey,
      productHeading: both ? 'Premium Set' : 'Classic Set',
      routineLabel: routine.label,
      sizeLabel,
      description: routine.description,
      perks: routine.perks,
      metrics: {
        share: quantities.share,
        plastic: quantities.plastic,
        savings: quantities.savings,
        shareSegments: quantities.impactSegments[0],
        plasticSegments: quantities.impactSegments[1],
        savingsSegments: quantities.impactSegments[2]
      },
      pricingMode,
      standardDiscountAmountMinor: standardDiscountAmounts[sizeKey][routineKey],
      discountCodes: {
        standardDiscount: standardDiscountCode(sizeKey, routineKey),
        giftDiscount: giftDiscountCode(sizeKey, routineKey)
      },
      fixedItems,
      choiceGroups,
      presets: makePresets(sizeKey, quantities)
    });
  }

  const recipes = ['s1', 's2', 's12'].flatMap((sizeKey) => (
    ['part', 'full', 'comfort', 'allin'].map((routineKey) => makeRecipe(sizeKey, routineKey))
  )).concat(['s1', 's2', 's12'].map((sizeKey) => makeRecipe(sizeKey, 'starter')));

  root.JudesBundleRecipes = Object.freeze({ version: 5, pricingMode, recipes: Object.freeze(recipes) });
}(typeof globalThis !== 'undefined' ? globalThis : this));
